export default __webpack_public_path__ + "9d561e93010d55d64bbdc3776bab2f88.svg";